export const formatFloatToHours = (value: number | null) => {
    if (!value) return '00h00m';
    if (value === 0) return '00h00m';
    const [hours, minutes] = value.toString().split('.');
    const h = hours.padStart(2, '0');
    const m = minutes ? minutes.padEnd(2, '0').slice(0, 2) : '00';
    return `${h}h${m}m`;
}
